import { assetURL, formatDisplayTime, getVideoType, placeholderSrc } from '~/utils'

import React from 'react'
import { withI18n } from '~/hocs'

const Video = ({ video, t }) => {
  const filename = video.pv_540 ? assetURL(`${video.pv_540}.mp4`) : assetURL(`${video.upload.s3_key}`)
  const thumbnail = video.pv_540 ? assetURL(`${video.pv_540}.jpg`) : undefined

  return (
    <>
      <article className="video-item" key={video.id}>
        <div className="video-item-wrapper-link">
          <img
            className="img-lazy-load-placeholder"
            src={placeholderSrc(16, 9)}
            alt={video.title}
          />
          <div className="player-wrapper">
            <video className='video-item-video' onContextMenu={(e) => e.preventDefault()} audio={video.has_audio} poster={thumbnail} controls controlsList="nodownload">
              <source src={`${filename}#t=${video.thumbnail_time}`} type="video/mp4"/>
            </video>
            {video.is_AI_video == 1 && <div className='AI-badge-video-detail d-flex'>
              <span className="mr-2">AI生成</span>
            </div>}
          </div>
          {/* <StickyVideo url={assetURL(filename)} audio={video.has_audio}/> */}
        </div>
      </article>
    </>
  )
}

export default withI18n(Video)
